// Sub-segment classification — the user-facing grouping above NACE.
// Set by the sub-segment classifier at ingestion time based on NACE + name +
// description heuristics. Entities can belong to a single primary sub-segment.

export const SUB_SEGMENTS = [
  'dental',
  'veterinary',
  'optical',
  'specialist_medical',
  'primary_care',
  'physiotherapy',
  'mental_health',
  'aesthetics',
  'fertility',
  'allied_health',
  'medical_retail',
  'residential_nursing',
  'social_care',
  'healthcare_it',
  'other_healthcare',
  // 2026 expansion — full UK SIC 2007 healthcare coverage. Mirrors
  // packages/db/src/schema/enums.ts subSegmentEnum.
  'hospitals',
  'nursing_homes_medical',
  'residential_care_mh',
  'residential_care_elderly',
  'residential_care_other',
  'pharma_wholesale',
  'community_pharmacy',
  'audiology',
] as const;

export type SubSegment = (typeof SUB_SEGMENTS)[number];

export const SUB_SEGMENT_LABELS: Record<SubSegment, string> = {
  dental: 'Dental',
  veterinary: 'Veterinary',
  optical: 'Optical',
  specialist_medical: 'Specialist medical',
  primary_care: 'Primary care',
  physiotherapy: 'Physiotherapy',
  mental_health: 'Mental health',
  aesthetics: 'Aesthetics',
  fertility: 'Fertility',
  allied_health: 'Allied health',
  medical_retail: 'Medical / orthopaedic retail',
  residential_nursing: 'Residential nursing',
  social_care: 'Social care',
  healthcare_it: 'Healthcare IT',
  other_healthcare: 'Other healthcare',
  hospitals: 'Hospitals',
  nursing_homes_medical: 'Nursing homes (medical)',
  residential_care_mh: 'Residential care (LD/MH)',
  residential_care_elderly: 'Residential care (elderly)',
  residential_care_other: 'Residential care (other)',
  pharma_wholesale: 'Pharma wholesale',
  community_pharmacy: 'Community pharmacy',
  audiology: 'Audiology / hearing aids',
};

// Three-letter codes for the asset-type chip rendered in front of each
// row across the platform. Mirrors SaxoTrader's `EQ` / `ETF` chips but
// surfaces a sub-segment instead of an asset class (every entity here
// is already a private company).
export const SUB_SEGMENT_CODES: Record<SubSegment, string> = {
  dental: 'DEN',
  veterinary: 'VET',
  optical: 'OPT',
  specialist_medical: 'SPC',
  primary_care: 'PRI',
  physiotherapy: 'PHY',
  mental_health: 'MEN',
  aesthetics: 'AES',
  fertility: 'FRT',
  allied_health: 'ALH',
  medical_retail: 'RTL',
  residential_nursing: 'NUR',
  social_care: 'SOC',
  healthcare_it: 'HIT',
  other_healthcare: 'OTH',
  hospitals: 'HSP',
  nursing_homes_medical: 'NHM',
  residential_care_mh: 'RMH',
  residential_care_elderly: 'RCE',
  residential_care_other: 'RCO',
  pharma_wholesale: 'PWS',
  community_pharmacy: 'CPH',
  audiology: 'AUD',
};
